import React from 'react';

import { LicenseInfo } from '@mui/x-license-pro';
import ReactDOM from 'react-dom';

import AppInit from './AppInit';
import AppProvider from './context';
import reportWebVitals from './reportWebVitals';
import { rootElement } from './theme';
import { AnnouncerProvider } from 'context/Announcer';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIX_LICENSE);

ReactDOM.render(
    <React.StrictMode>
        <AppProvider>
            <AnnouncerProvider>
                <AppInit />
            </AnnouncerProvider>
        </AppProvider>
    </React.StrictMode>,
    rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
